<template>
  <Button
    class="scroll-to-top-button"
    type="primary"
    size="lg"
    theme="accent"
    @click="scrollToTop"
  >
    <i class="scroll-to-top-button__icon fa-solid fa-angles-up" />
  </Button>
</template>

<script setup lang="ts">
  import Button from "./Button.vue";

  const { y } = useScroll(window, {
    behavior: 'instant'
  });

  let scrollInterval: any = null;

  function stopScroll() {
    if (scrollInterval !== null) {
      clearInterval(scrollInterval);
      scrollInterval = null;
    }
  }

  function scrollToTop() {
    stopScroll();
    scrollInterval = setInterval(() => {
      const step = y.value / 50;
      if (y.value > 0) {
        y.value -= step;
      } else {
        stopScroll();
      }
    }, 5);
  }

  function handleUserScroll() {
    stopScroll();
  }

  onMounted(() => {
    window.addEventListener("wheel", handleUserScroll);
    window.addEventListener("touchmove", handleUserScroll);

    return () => {
      window.removeEventListener("wheel", handleUserScroll);
      window.removeEventListener("touchmove", handleUserScroll);
      stopScroll();
    };
  });
</script>

<style lang="scss">
  .scroll-to-top-button {
    min-width: 0 !important;

    &__icon {
      font-size: 16px;
    }
  }
</style>
